/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState, useEffect } from 'react'
import { STAGE } from '../../config'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail,ShimmerSectionHeader, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'
import { AllRolesList } from '../../pages/ManageInstitutionUsers/roles'

export default function ViewAllRolesShimmer() {
    return (
         
            
        <div class=" w-[80%] mx-auto">
            <p className="text-2xl font-bold text-[#031624] mt-3"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[100px]"/></p>
            <div class="border border-[#C2DCEF] rounded mt-[18px] px-[25px] py-[29px] err-border1">
                {Object.keys(AllRolesList).map((item) => (
                    <div key={item}>
                        <p className="text-2xl font-bold text-[#031624] mt-1"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[130px]"/></p>
                        <div class="flex -mx-1 flex-wrap">
                            {AllRolesList[item].map((subitem) => (
                                <div class="px-1 w-1/5 mb-6" key={subitem}>
                                    <div class="w-full">
                                        <div class="flex">

                                            <p className="text-2xl font-bold text-[#031624] mt-2"><ShimmerTitle line={1} gap={10} variant="secondary" className="w-[130px]"/></p>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>))}
            </div>
        </div>
    )
}
